var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAscendingArrow = function SvgAscendingArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.031 10.122a.312.312 0 1 0 .625 0zM5.565.84a.31.31 0 0 0-.442 0L3.134 2.827a.312.312 0 1 0 .442.442l1.768-1.767 1.768 1.767a.312.312 0 1 0 .441-.442zm.091 9.283V1.06h-.625v9.062z"
  })));
};
export default SvgAscendingArrow;